module.exports = __webpack_public_path__ + "media/images/grade/E-df4a37217c0157eb9d44b5391ba6bb6c.svg";